module.exports = __webpack_public_path__ + "img/headshot-gina-papalia@2x.2f954d3d.jpg";